export default {
    name: 'Blazon',
    props: {
        settings: {
            type: Object,
            required: true,
        },
    },
}
